import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import isSubscribed from "../../../../../helpers/isSubscribed";
import { Score } from "../../../../../services/scoresGet";
import { ScoresState } from "../../../../../store/scores/types";
import { AppState } from "../../../../../store/store";
import Message from "../Message";
import Info from "./Info";
import Risk from "./Risk";

interface Props {
  scoresState: ScoresState;
}

const ScoreContainer = ({ scoresState }: Props) => {
  const userIsSubscribed = isSubscribed();
  const [scores, setScores] = useState<Score[]>([]);

  useEffect(() => {
    if (scoresState.status === "loaded") {
      const scores = scoresState.payload;
      setScores(scores.puntajes);
    }
  }, [scoresState.status]);

  if (userIsSubscribed) {
    return (
      <>
        <Info />
        <Risk scores={scores} />
      </>
    )
  }

  return (
    <Message
      title="Descubre más sobre tu puntaje"
      description="Accede a información clave sobre cómo se calcula y qué hacer para mejorarlo."
      CTA="Consultar mi score"
    />
  )
}

const mapStateToProps = (state: AppState) => ({
  scoresState: state.scores,
});

export default connect(mapStateToProps)(ScoreContainer);